import { render, staticRenderFns } from "./RegComplete.vue?vue&type=template&id=26818126&"
import script from "./RegComplete.vue?vue&type=script&lang=js&"
export * from "./RegComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegComplete.vue?vue&type=style&index=0&id=26818126&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports